import React,{useEffect, useState} from 'react';
import {  KoButton, KoDataTableEdit,KoNano,KoForm } from 'packages';
import KoIcon from '@kwapio/icons';
import styles from './recurringorder.module.scss';

function ItemEntryCrud({ form,handleFinish, initialValues}) {

  const [dataSource, setDataSource] = useState();

  useEffect(() => {
    if (initialValues?.agenda) {
      setDataSource(initialValues.agenda);
    } else {
      setDataSource([{
        key: KoNano('CAL'),
        title: null,
        presenter: null,
        dueDate: null,
        status: null
      }]);
    }
  }, [initialValues]);




  const columns = [
    {
      dataIndex: 'itemdetails',
      title: 'Item Details',
      width: 200,
      editable: true,
      widget: 'text',
      placeholder: 'Enter Item Details...'
    },
    {
      dataIndex: 'account',
      title: 'ACCOUNT',
      width: 200,
      editable: true,
      widget: 'options',
      placeholder: 'Account',
      options:[{
        value:1,
        label:'Bank Transfer'
      },{
        value:2,
        label:'Phone Pay'
      },{
        value:3,
        label:'Gpay'
      }]
    },
    {
      dataIndex: 'quantity',
      title: 'QUANTITY',
      width: 200,
      editable: true,
      widget: 'text',
      placeholder: '1.00'
    },
    {
      dataIndex: 'rate',
      title: 'RATE',
      width: 200,
      editable: true,
      widget: 'text',
      placeholder: '0.00'
    },
    {
      dataIndex: 'tax',
      title: 'TAX',
      width: 200,
      editable: true,
      widget:'options',
      options:[
        { label: 'Non-Texable', value: 'non-texable' },
        { label: 'IGST0 [0%]', value: '0' },
        { label: 'IGST5 [5%]', value: '5' },
        { label: 'IGST10 [10%]', value: '10' }
      ],
      placeholder: '0.00'
    },
    {
      dataIndex: 'amount',
      title: 'AMOUNT',
      width: 200,
      editable: true,
      widget: 'text',
      placeholder: '0.00'
    },
    {
      title: ` `,
      dataIndex: 'operation',
      width: 40,
      render: (_, record, i) =>
        dataSource.length >= 1 ? (
          <div className={'editTableCol'}>
            <KoButton icon={<KoIcon width={12} height={12} name={'DeleteOutlined'} />} className={styles.actionBtn} onClick={() => handleDelete(record?.key)} label="" />
            {dataSource?.length === (i+1) && <KoButton icon={<KoIcon color={`var(--palette-gray-7)`} width={17} height={17} name={'PlusOutlined'} />} className={styles.actionBtn} onClick={() => handleAdd(record?.key)} label={``} />}
          </div>
        ) : null
    }
  ];

  const handleDelete = (key) => {
    let newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    if(newData.length === 0){
      newData =[{
        key: KoNano('TAX'),
        taxName: null,
        taxRate: null,
        isDefault: false
      }];
    }
    handleSave(newData);
  };

  const handleAdd = () => {
    const newData = {
      key: KoNano('CAL'),
      title: ``,
      presenter: '',
      dueDate: '',
      status: ''
    };
    setDataSource([...dataSource, newData]);
  };

  const handleSave = (newData) => {
    let data = form.getFieldsValue();
    data['agenda'] = newData;
    form.setFieldsValue({...data});
    setDataSource(newData);
  };
  return (
    <div className={styles.itemwrapper}>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <KoForm.Item name={'agenda'}>
          <KoDataTableEdit
            dataSource={dataSource}
            form={form}
            onSave={handleSave}
            defaultColumns={columns} />
        </KoForm.Item>
      </KoForm>
    </div>
  );
};

export default ItemEntryCrud;